<script setup lang="ts">
import type { MutationStatus } from "@tanstack/vue-query";
import { ref } from "vue";
import type { NewComment } from "./types";

defineProps<{
  creatingStatus: MutationStatus;
  error: Error | null | undefined;
}>();

const emit = defineEmits<{
  submit: [comment: NewComment];
}>();

const content = ref("");

const handleSubmit = () => {
  if (content.value.trim()) {
    emit("submit", { id: window.crypto.randomUUID(), content: content.value });
    content.value = "";
  }
};
</script>

<template>
  <article>
    <form class="column" @submit.prevent="handleSubmit">
      <div>
        <label for="newComment" class="visually-hidden"
          >Neuen Kommentar verfassen</label
        >
        <textarea
          id="newComment"
          v-model="content"
          rows="4"
          placeholder="Neuen Kommentar verfassen..."
          required
        ></textarea>
        <small v-if="creatingStatus == 'error'" class="error">
          {{ error?.message }}
        </small>
      </div>
      <div class="row row-end">
        <button
          class="button"
          type="submit"
          :aria-busy="creatingStatus == 'pending'"
        >
          Speichern
        </button>
      </div>
    </form>
  </article>
</template>
